var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-container',{attrs:{"id":"login-account","fluid":"","tag":"section"}},[_c('v-row',{attrs:{"justify":"center"}},[_vm._v(" Re-loading ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }